export const WALTER_CHAT_MESSAGE_KEY = 'walter-chat-messages'